var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.created)?_c('v-app',[_c('v-main',{staticStyle:{"min-height":"calc(100vh - 64px)"}},[(_vm.created === true)?_c('ServiceNavigationDrawer'):_vm._e(),_c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[(_vm.created)?_c('router-view',{key:_vm.reloadRouter}):_vm._e()],1)],1),(_vm.created === true)?_c('ServiceFooter'):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }